/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 5/01/2023
 */
import React, { useState, useEffect } from "react";
import {
  Stack,
  LinearProgress,
  Paper,
  InputBase,
  IconButton,
} from "@mui/material"
import PendingRoleItem from "./PendingRoleItem";
import api from "../../services/AuthApi";
import { FetchErrorHandeling } from "../../errorHandeling/FetchErrorHandeling";
import Alerts from "../../errorHandeling/Alerts";
import SearchIcon from "@mui/icons-material/Search"

const PendingRoles = ({
  setIsPendingChange,
  isPendingChange,
  isChange,
  setIsChange,
  setPendingCount,
}) => {
  const [pendingData, setPendingData] = useState([]);
  const [filterData, setfilterData] = useState([])
  const [pendingLoading, setPendingLoading] = useState(true);

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [iserrorShow, setIserrorShow] = useState(false);
  const [isUnauhtError, setIsUnauhtError] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  let pendingConfig = {
    headers: {
      Action: "VNAR",
      "Sort-Field": "roleId",
      "Page-OffSet": 0,
      "Page-Size": 500,
    },
  };

  useEffect(() => {
    setPendingLoading(true);
    setIsChange(false);
    setIsPendingChange(false);
    api
      .get("/role/permissions", pendingConfig)
      .then((res) => {
        setPendingData(res.data?.dataList[0]?.rolePerms);
        setfilterData(res.data?.dataList[0]?.rolePerms)
        setPendingCount(res.data?.total);
        setPendingLoading(false);
        setErrorMessages([]);
        setIserror(false);
        setIsUnauhtError(false);
      })
      .catch((error) => {
        console.log(error);
        setPendingLoading(false);
        FetchErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        );
      });
  }, [isChange, isPendingChange, isUnauhtError]);

  useEffect(() => {
    if (isSuccess === true) {
      setTimeout(() => {
        setIsSuccess(false);
        setSuccessMessages([]);
      }, 10000);
    }
  }, [isSuccess]);

  const searchFilter = (e) => {
    const searchVal = e.target.value
     const results = pendingData.filter((roleData) => {
       return roleData.role.toLowerCase().includes(searchVal.toLowerCase())
     })
    setfilterData(results)
  }

  const permissions = (perms) => {
    return perms?.map((p) => ({ permission: p.permission }));
  };

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          isSuccess={isSuccess}
          successMessages={successMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: 400 }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search Organization"
          inputProps={{ "aria-label": "search organization" }}
          onChange={searchFilter}
        />
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
        </IconButton>
      </Paper>
      <br />
      {pendingLoading ? (
        <LinearProgress />
      ) : (
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          flexWrap="wrap"
        >
          {filterData?.map((d, i) => {
            return (
              <PendingRoleItem
                key={d?.role}
                roleTitle={d?.role}
                level={d?.level}
                desc={d?.desc}
                action={d?.action}
                approveId={d?.approveId}
                perms={permissions(d?.permissions)}
                setIsPendingChange={setIsPendingChange}
                setIserror={setIserror}
                setErrorMessages={setErrorMessages}
                setIsUnauhtError={setIsUnauhtError}
                setIserrorShow={setIserrorShow}
                setIsSuccess={setIsSuccess}
                setSuccessMessages={setSuccessMessages}
              />
            )
          })}
        </Stack>
      )}
    </div>
  )
};
export default PendingRoles;
